import React, { useEffect, useState, useRef, useContext } from "react";
import {
  Typography,
  Box,
  Popper,
  ClickAwayListener,
  Paper,
  Badge,
  Button,
  DialogTitle,
  DialogContent,
  IconButton,
  Divider,
  Grow,
} from "@material-ui/core";
import { useStyles } from "../infosBenevole/InfosBenevole.css";
import rest from "../../rest";
import { useSelector } from "react-redux";
import { useGlobalContext } from "../general/globalContexte";
import PhoneIcon from "@material-ui/icons/Phone";
import HomeIcon from "@material-ui/icons/Home";
import CakeIcon from "@material-ui/icons/Cake";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import GetRandomKey from "../general/genereRandomKey";
import InfosBenevole from "../infosBenevole/InfosBenevole";
import DoneIcon from "@material-ui/icons/Done";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import { useStylesOnglet } from "../onglets/Onglets.css";
import { formatTimeToDate } from "../general/formateDate";
import AppContext from "../appContext";
import { useStylesGlobal } from "../../pages/GlobalStyle.css";
import { dicoColorLevel } from "../onglets/OngletRemarque";
import { Add } from "@material-ui/icons";
import IconButtonStyled from "../general/IconButtonStyled";

const PopperTipsBenevol = ({
  idBenevole,
  person,
  text,
  componentKey,
  showEdit = true,
  closePopper,
  beforeClosingFiche,
}) => {
  const classes = useStyles();
  const [avatarPix, setAvatarPix] = useState(
    `/4DACTION/IMAGE_PROFILE/?person=${idBenevole}`
  );
  const [benevol, setBenevol] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [hasCompteUser, setHasComptUser] = useState(false);
  const [openFicheUser, setOpenFicheUser] = useState(false);
  const [loading, setLoading] = useState(false);

  const anchorRef = useRef(null);
  const popupRef = useRef(null);
  const timerRef = useRef(null);

  const { openStatesPopper, setOpenStatesPopper } = useGlobalContext();
  const currentUser = useSelector((state) => state.user);
  const classesOnglet = useStylesOnglet();

  const myContext = useContext(AppContext);
  myContext.benevole = person;

  const stylesGlobal = useStylesGlobal();

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (person) {
      setBenevol(person);
      setHasComptUser(person.Person_Profile);
    } else {
      let url = `/4DACTION/IMAGE_PROFILE/?person=${idBenevole}&alea=` +  Math.floor(Math.random() * 1000000);
      setAvatarPix(url);
    }
  }, [idBenevole, person]);

  useEffect(() => {
    const handleMouseLeave = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.relatedTarget)) {
        handleDelayedClose();
      }
    };

    if (open) {
      window.addEventListener("mouseleave", handleMouseLeave);
      return () => {
        window.removeEventListener("mouseleave", handleMouseLeave);
      };
    }
  }, [open]);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
    clearTimeout(timerRef.current);

    timerRef.current = setTimeout(() => {
      let tmp = {};
      tmp[componentKey] = true;
      setOpenStatesPopper({ ...tmp });
      setOpen(true);
      let params = { vID: idBenevole };
      setLoading(true);
      rest.post("/benevols/info.json", params).then((response) => {
        setBenevol(response.data.benevole);
        setHasComptUser(response.data.benevole.Person_Profile);
        setOpen(true);
        setLoading(false);
      });
    }, 300);
  };

  const handleClose = () => {
    setOpen(false);
    let tmp = { ...openStatesPopper };
    tmp[componentKey] = false;
    setOpenStatesPopper({ ...tmp });
    handleStopTimer();
    if (closePopper) closePopper();
  };

  const handleDelayedClose = () => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setOpen(false);
    }, 300);
  };

  const handleStopTimer = () => {
    clearTimeout(timerRef.current);
  };

  const handleFicheBenevole = () => {
    handleClose();
    setOpenFicheUser(true);
  };

  const formatName = (name) => {
    name = name.trim();
    const string = name.replace(/([A-Z])/g, " $1").toLowerCase();
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const closeFiche = () => {
    setOpenFicheUser(false);
    if (beforeClosingFiche) beforeClosingFiche();
  };

  const ficheBenevole = () => (
    <InfosBenevole
      readOnly={!currentUser?.User?.User_Administrator}
      idBenevole={idBenevole}
      benevSelectedName={benevol?.Person_Name}
      benevSelectedFirstName={benevol?.Person_Firstname}
      handleClose={closeFiche}
      style={{ textTransform: "none" }}
      refreshBen={myContext.refreshBen}
      setRefreshBen={myContext.setRefreshBen}
      initialTab={10}
    />
  );

  return (
    <>
      <Box
        component="div"
        ref={anchorRef}
        onMouseEnter={handleOpen}
        onMouseLeave={() => handleDelayedClose()}
        style={{ display: "inline-block", cursor: "pointer", fontSize: "14px" }}
      >
        <Button>
          <strong>{text}</strong>
        </Button>
        <Popper
          open={open && !loading}
          anchorEl={anchorEl}
          placement="bottom-start"
          transition
          style={{ zIndex: 2000, minWidth: "20vw" }}
        >
          {({ TransitionProps }) => (
            <Grow {...TransitionProps} timeout={300}>
              <Paper
                ref={popupRef}
                style={{
                  zIndex: 2000,
                  borderRadius: 8,
                  padding: 16,
                  border: "1px solid #ddd",
                }}
                elevation={24}
              >
                <DialogTitle>
                  <Box display="flex" alignItems="center">
                    <Box flexGrow={1}>
                      <Typography variant="h6">
                        {`${benevol?.Person_Firstname} ${benevol?.Person_Name}`}
                      </Typography>
                      {currentUser?.User?.User_Administrator && showEdit && (
                        <IconButton
                          onClick={handleFicheBenevole}
                          color="primary"
                        >
                          <AssignmentIndIcon />
                        </IconButton>
                      )}
                    </Box>
                    <Box>
                      <img
                        alt="Profil user"
                        src={avatarPix}
                        className={classes.popperTipImage}
                      />
                      {hasCompteUser && (
                        <Badge
                          badgeContent={
                            <DoneIcon className={classesOnglet.smallIcon} />
                          }
                          classes={{ badge: classesOnglet.orangeBadge }}
                          style={{ top: 5, right: 30 }}
                          title="A un compte utilisateur"
                          overlap="rectangular"
                        />
                      )}
                    </Box>
                  </Box>
                </DialogTitle>
                <Divider style={{ margin: "16px 0" }} />
                <DialogContent>
                  <ClickAwayListener onClickAway={handleClose}>
                    <Box component="div">
                      <Box component="div">
                        <Box className={classes.infoDetails} component="div">
                          <Box
                            className={classes.info}
                            display="flex"
                            alignItems="center"
                          >
                            <PhoneIcon /> :{" "}
                            {`${
                              benevol?.Person_Phone_Mobile?.trim() ||
                              benevol?.Person_Phone_Pers?.trim() ||
                              benevol?.Person_Phone_Pro?.trim() ||
                              ""
                            }`}
                          </Box>
                          <Box
                            className={classes.info}
                            display="flex"
                            alignItems="center"
                          >
                            <HomeIcon /> :{" "}
                            {`${
                              benevol?.Person_Address?.trim() ||
                              benevol?.Person_Address_2?.trim() ||
                              benevol?.Person_Address_3?.trim() ||
                              ""
                            }`}
                          </Box>
                          <Box
                            className={classes.info}
                            display="flex"
                            alignItems="center"
                          >
                            <CakeIcon /> :{" "}
                            {`${new Date(
                              benevol?.Person_Birth
                            ).toLocaleDateString("fr-CH")} - ${Math.floor(
                              (new Date() - new Date(benevol?.Person_Birth)) /
                                (365.25 * 24 * 60 * 60 * 1000)
                            )} ans`}
                          </Box>
                          {benevol?.Person_Tshirt && (
                            <Box
                              className={classes.info}
                              display="flex"
                              alignItems="center"
                            >
                              <PersonOutlineIcon /> : {benevol?.Person_Tshirt}
                            </Box>
                          )}
                          <Box
                            className={classes.info}
                            display="flex"
                            alignItems="center"
                          >
                            <MailOutlineIcon /> : {benevol?.Person_Email}
                          </Box>
                          {benevol?.Person_LastInscription && (
                            <Box
                              className={classes.info}
                              display="flex"
                              alignItems="center"
                            >
                              <AccessTimeIcon /> {" : "} Dernière inscription{" "}
                              {formatTimeToDate(
                                benevol?.Person_LastInscription,
                                true
                              )}
                            </Box>
                          )}
                          <Box
                            component="div"
                            onClick={() => {
                              showEdit && handleFicheBenevole();
                            }}
                            className={
                              stylesGlobal[
                                dicoColorLevel[person?.Person_RemarqueLevel]
                              ]
                            }
                            style={{ padding: 5 }}
                          >
                            {person?.Person_Remarque ? (
                              <Typography
                                component="div"
                                className={classes.info}
                              >
                                {person?.Person_Remarque}
                              </Typography>
                            ) : (
                              showEdit && (
                                <Box display="flex" alignItems="center">
                                  Ajouter une remarque
                                  <IconButtonStyled
                                    variant="outlined"
                                    style={{
                                      width: 25,
                                      height: 25,
                                      padding: 1,
                                      marginLeft: 10,
                                    }}
                                    iconSize={16}
                                    tooltipTitle="Chat"
                                    color="blueBtn"
                                    className={classes.info}
                                  >
                                    <Add />
                                  </IconButtonStyled>
                                </Box>
                              )
                            )}
                          </Box>
                        </Box>
                      </Box>
                      <Box>
                        {benevol?.Person_InfosComples &&
                          benevol.Person_InfosComples !== "undefined" &&
                          benevol.Person_InfosComples !== "" && (
                            <Box component="div">
                              <Divider style={{ margin: "16px 0" }} />
                              <Typography
                                color="inherit"
                                className={classes.title}
                              >
                                Infos complémentaires
                              </Typography>
                              <Typography
                                color="inherit"
                                variant="body2"
                                className={classes.info}
                                component="div"
                              >
                                {(() => {
                                  let infosComples =
                                    benevol.Person_InfosComples;
                                  if (typeof infosComples === "string") {
                                    try {
                                      infosComples = JSON.parse(infosComples);
                                    } catch (e) {
                                      console.error(
                                        "Erreur de parsing JSON : ",
                                        e
                                      );
                                      infosComples = null;
                                    }
                                  }
                                  if (infosComples?.InfosComplementaires) {
                                    return infosComples.InfosComplementaires.map(
                                      (info) => (
                                        <Box
                                          key={GetRandomKey(9)}
                                          component="div"
                                        >
                                          <Typography
                                            component="span"
                                            className={classes.info}
                                          >
                                            <strong>
                                              {formatName(info.nom)}:
                                            </strong>{" "}
                                            {info.valeur}
                                          </Typography>
                                        </Box>
                                      )
                                    );
                                  } else {
                                    return null;
                                  }
                                })()}
                              </Typography>
                            </Box>
                          )}
                      </Box>
                    </Box>
                  </ClickAwayListener>
                </DialogContent>
              </Paper>
            </Grow>
          )}
        </Popper>
        {openFicheUser && ficheBenevole()}
      </Box>
    </>
  );
};

export default PopperTipsBenevol;
